export default __webpack_public_path__ + "static/epica-lite-8-1ef63128925ff1758e3d9f2c34dd756a.jpg";